(function () {
  let scrollbarSettings = {
    slidesPerView: 2,
    spaceBetween: 16,
    speed: 400,
    allowTouchMove: true,
    mousewheel: {
      forceToAxis: true,
    },
    watchSlidesProgress: true,
    breakpoints: {
      990: {
        slidesPerView: 3,
      },
      1440: {
        slidesPerView: 4,
      },
    },
  };

  let sliderSettings = {
    slidesPerView: 1,
    spaceBetween: 16,
    speed: 500,
    allowTouchMove: true,
  };

  const initSliders = (section, settings, layouts) => {
    const swiperEls = layouts || section.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = swiperEl.querySelector(".products-tabs__list");
      const slides = swiperEl.querySelectorAll(".products-tabs__item");

      if (!swiperWrapper || !slides || !slides.length) return;

      const mobSlidesPreView = swiperEl.classList.contains(
        "products-tabs__layout--visible-overflow"
      )
        ? "auto"
        : 1;

      swiperEl.classList.add("swiper");
      swiperWrapper.classList.add("swiper-wrapper");
      slides.forEach((slide, index) => {
        slide.classList.add("swiper-slide");
        let coeff = slides.length > 12 ? 0.05 : 0.1;

        if (slides.length > 24) {
          coeff = 0.02;
        }

        const delay = index * coeff;
        slide.style.setProperty("--prod-tabs-item-delay", `${delay}s`);
      });

      const progressBar = swiperEl.querySelector(".swiper-scrollbar");
      const nextBtn = swiperEl.querySelector(
        ".products-tabs__navigation-button-next"
      );
      const prevBtn = swiperEl.querySelector(
        ".products-tabs__navigation-button-prev"
      );

      scrollbarSettings = {
        ...scrollbarSettings,
        scrollbar: {
          el: progressBar,
          grabCursor: true,
          draggable: true,
          hide: false,
        },
      };

      sliderSettings = {
        ...sliderSettings,
        slidesPerView: mobSlidesPreView,
        navigation:
          nextBtn && prevBtn
            ? {
                nextEl: nextBtn,
                prevEl: prevBtn,
                disabledClass: "swiper-button-disabled",
              }
            : false,
      };

      new Swiper(
        swiperEl,
        settings === "bar" ? scrollbarSettings : sliderSettings
      );
    });
  };

  const destroySliders = (section) => {
    const swiperEls = section.querySelectorAll(".products-tabs__layout");

    swiperEls.forEach((swiperEl) => {
      const swiperWrapper = section.querySelector(".products-tabs__list");
      const slides = section.querySelectorAll(".products-tabs__item");

      if (!swiperEl?.swiper || !slides.length || !swiperWrapper) return;

      swiperEl.swiper.destroy();

      swiperEl.classList.remove("swiper");
      swiperWrapper.classList.remove("swiper-wrapper");
      slides.forEach((slide) => slide.classList.remove("swiper-slide"));
    });
  };

  const toggleTab = (section) => {
    const tabsEls = section.querySelectorAll(".products-tabs__tab");
    const productsEls = section.querySelectorAll(".products-tabs__layout");

    const onToggleTab = (event, tab) => {
      event.preventDefault();
      if (tab.classList.contains("active")) return;
      const tabId = tab.dataset.productsTabId;

      tabsEls.forEach((el) => {
        el.classList.remove("active");
      });

      productsEls.forEach((el) => {
        el.classList.remove("active");

        if (el.swiper) {
          el.swiper.slideTo(0, 0);
        }
      });

      const productsActiveEl = section.querySelector(
        `.products-tabs__layout[data-products-tab-id="${tabId}"]`
      );
      tab.classList.add("active");
      productsActiveEl.classList.add("active");
    };

    tabsEls.forEach((tab) => {
      tab.addEventListener("click", (event) => onToggleTab(event, tab));

      tab.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          onToggleTab(event, tab);
        }
      });
    });
  };


  const redropWallTime = (date) => {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles", year: "numeric", month: "2-digit",
      day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit",
      hourCycle: "h23"
    }).formatToParts(date);
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return Date.UTC(+values.year, +values.month - 1, +values.day,
      +values.hour, +values.minute, +values.second);
  };

  const redropWeek = (now = new Date()) => {
    const wall = redropWallTime(now);
    const day = new Date(wall);
    day.setUTCHours(8, 0, 0, 0);
    let start = day.getTime() - ((day.getUTCDay() + 5) % 7) * 86400000;
    if (wall < start) start -= 604800000;
    return { start, index: Math.floor((start - Date.UTC(2026, 0, 6, 8)) / 604800000) };
  };

  const selectRedropItems = (items, now = new Date()) => {
    const week = redropWeek(now);
    const unique = Array.from(new Map(items.map(item => [item.dataset.productId, item])).values());
    const landed = item => Number(item.dataset.productPublishedAt || item.dataset.productCreatedAt) * 1000;
    const isFresh = item => {
      const timestamp = landed(item);
      return Number.isFinite(timestamp) && timestamp > 0 && timestamp <= now.getTime()
        && redropWallTime(new Date(timestamp)) >= week.start - 604800000;
    };
    const fresh = unique.filter(isFresh).sort((a, b) => landed(b) - landed(a));
    const older = unique.filter(item => !isFresh(item)).sort((a, b) =>
      a.dataset.productId.localeCompare(b.dataset.productId, "en", { numeric: true }));
    const offset = older.length ? ((week.index * 4) % older.length + older.length) % older.length : 0;
    return [...fresh, ...older.slice(offset), ...older.slice(0, offset)].slice(0, 20);
  };

  const loadDynamicProducts = async (section, onLoaded) => {
    const isWeekly = /redrop/i.test(section.querySelector(".products-tabs__title")?.textContent || "");
    const layouts = section.querySelectorAll("[data-aic-collection-url]");
    await Promise.allSettled(Array.from(layouts, async (layout) => {
      if (layout.dataset.aicProductsState) return;
      layout.dataset.aicProductsState = "loading";
      const url = new URL(layout.dataset.aicCollectionUrl, location.origin);
      url.searchParams.set("view", "aic-redrop-products");
      url.searchParams.set("sort_by", "created-descending");
      url.searchParams.set("preview_theme_id", layout.dataset.aicThemeId);
      const items = [];
      const ids = new Set();
      const week = redropWeek();
      url.searchParams.set("_aic_week", String(week.start));
      let pagesRead = 0;
      let nextUrl = url;
      try {
        while (nextUrl && items.length < (isWeekly ? 100 : 20) && pagesRead < 20) {
          pagesRead += 1;
          const response = await fetch(nextUrl, { credentials: "same-origin", cache: "no-store" });
          if (!response.ok) throw new Error("Unable to load ReDrop category");
          const doc = new DOMParser().parseFromString(await response.text(), "text/html");
          const source = doc.querySelector("[data-aic-redrop-products]");
          if (!source) throw new Error("ReDrop category response is missing");
          for (const item of source.querySelectorAll(".products-tabs__item")) {
            if (!ids.has(item.dataset.productId) && items.length < (isWeekly ? 100 : 20)) {
              ids.add(item.dataset.productId);
              items.push(item);
            }
          }
          const page = source.dataset.nextPage;
          nextUrl = page ? new URL(url) : null;
          if (nextUrl) nextUrl.searchParams.set("page", page);
        }
        if (!section.isConnected) return;
        if (layout.swiper) layout.swiper.destroy(true, true);
        const wrapper = layout.querySelector(".products-tabs__list");
        wrapper.replaceChildren(...(isWeekly ? selectRedropItems(items) : items));
        layout.dataset.aicRedropWeek = String(week.start);
        layout.classList.remove("products-tabs__layout--placeholder");
        layout.dataset.aicProductsState = "loaded";
        onLoaded(layout);
      } catch (error) {
        layout.dataset.aicProductsState = "error";
        console.error("ReDrop category:", error);
      }
    }));
  };

  const initProductsTabs = (section) => {
    if (!section || !section?.classList.contains("products-tabs-section")) {
      return;
    }

    const sliderContainer = section.querySelector(".products-tabs");
    const cardsLayout = sliderContainer.dataset.layout || "grid";
    const cardsMobileLayout = sliderContainer.dataset.layoutMobile || "column";

    let currentLayout = null;

    const sectionResizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        let newLayout;

        if (entry.contentRect.width < 576) {
          newLayout = cardsMobileLayout === "slider" ? "slider" : "column";
        } else {
          newLayout = cardsLayout === "bar" ? "bar" : "grid";
        }

        if (newLayout !== currentLayout) {
          currentLayout = newLayout;

          destroySliders(section);

          if (newLayout === "slider" || newLayout === "bar") {
            initSliders(section, newLayout);
          }
        }
      });
    });

    sectionResizeObserver.observe(section);

    toggleTab(section);
    loadDynamicProducts(section, (layout) => {
      if (currentLayout === "slider" || currentLayout === "bar") {
        initSliders(section, currentLayout, [layout]);
      }
    });
  };

  const animateProductCards = (section) => {
    if (
      !section ||
      !section?.classList.contains("products-tabs-section") ||
      !section.querySelector(".animate-on-scroll")
    ) {
      return;
    }

    const productsTabsInner = section.querySelector(".products-tabs__inner");

    if (!productsTabsInner) return;

    ScrollTrigger.create({
      trigger: productsTabsInner,
      start: "20% bottom",
      end: "bottom top",
      onEnter: () => productsTabsInner.classList.add("animated"),
    });
  };

  initProductsTabs(document.currentScript.parentElement);

  animateProductCards(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initProductsTabs(event.target);
    animateProductCards(event.target);
  });
})();
